import Splide from "@splidejs/splide";

class ProductSlider {
  init() {
    if(document.querySelector('#splide')) {
      new Splide("#splide", {
        perPage: 5,
        perMove: 1,
        type: "loop",
        pagination: false,
        arrows: true,
        width: "90%",
        rewind: true,
        gap: "120px",
        speed: 300,
        autoplay: true,
        interval: 2000,
        pouseOnHover: true,
        resetProgress: true,
        breakpoints: {
          1550: {
            perPage: 4,
            gap: "80px"
          },
          992: {
            perPage: 3,
            gap: "50px"
          },
          768: {
            perPage: 5,
            arrows: false,
            gap: "30px"
          },
          576: {
            perPage: 3,
            arrows: false,
            gap: "15px"
          }
        }
      });
    }
  }
}

export default ProductSlider;
